import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.css'],
    standalone: false
})
export class TooltipComponent implements OnInit {

  @Input() public tip: any;

  constructor() { }

  ngOnInit(): void {
  }

}
